module.exports = __webpack_public_path__ + "img/latest-result-banner-bg-2.f8874604.webp";